import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, LoadingController, ModalController, ToastController, Config, Platform } from '@ionic/angular';
import * as _moment from 'moment';
import { DecimalPipe } from '@angular/common'
import { LoginObjectService } from '../services/login-object.service';
import { Storage } from '@ionic/storage-angular';
import { OfertaObject } from './../../assets/data/interfaces/oferta.interface';
import { Vibration } from '@awesome-cordova-plugins/vibration/ngx';
import { NativeAudio } from '@awesome-cordova-plugins/native-audio/ngx';
import { ApiService } from '../services/api.service';


_moment.locale('es-ES');
const moment = _moment;

@Component({
  selector: 'app-subasta',
  templateUrl: './oferta.page.html',
  styleUrls: ['./oferta.page.scss'],
})
export class OfertaPage implements OnInit, OnDestroy {
  loadInterval;
  clockInterval;
  clockTime = 0;
  timeRefresh = false;
  interval;
  intervalTime = 1000;
  cliente;
  horaReloj = ["00", "00", "00"];
  relojActivo = 0;
  ofertas: Array<OfertaObject>;
  fecha = moment().format("DD/MM/YYYY");
  defaultHref = '';
  divisible = 0;
  screenWidth;
  soundFile = "assets/data/mp3/beep.mp3";

  constructor(
    public loginObjectService: LoginObjectService,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public router: Router,
    public activateRoute: ActivatedRoute,
    public toastCtrl: ToastController,
    public config: Config,
    public decimalPipe: DecimalPipe,
    public storage: Storage,
    public platform: Platform,
    public apiService: ApiService,
    public vibration: Vibration,
    public nativeAudio: NativeAudio,
  ) { }
  ngOnDestroy(): void {
    clearInterval(this.clockInterval);
    clearInterval(this.interval);
    clearInterval(this.loadInterval);
  }



  ngOnInit() {
    this.defaultHref = `/subastas`;
    this.screenWidth = this.platform.width();
    this.activateRoute.queryParams.subscribe(data => {
      if (data.userId) {
        this.cliente = data.userId;
      } else {
        this.cliente = this.loginObjectService.getUsername();
      }
      this.storage.get("user").then(data => {
        this.loginObjectService.setUsername(data.username);
        this.loginObjectService.setRoles(data.roles);
        this.loginObjectService.setUserId(data.userId);
        this.loginObjectService.setClientes(data.clientes);
        this.apiService.getListaOfertas().subscribe(data => {
          if (data && data.ofertas) {
            this.ofertas = data.ofertas;
            clearInterval(this.clockInterval);
            clearInterval(this.interval);
            clearInterval(this.loadInterval);
            let start = new Date().getTime() / 1000
            this.apiService.actualizarPujas({ id: this.loginObjectService.getclientes() }).subscribe((dataActu) => {
              let tiempoRespuesta = Math.ceil((new Date().getTime() / 1000) - start)
              this.timeRefresh = true;
              this.clockTime = dataActu.time.seconds - tiempoRespuesta
              this.interval = setInterval(() => {
                this.actualizarPujas();
              }, this.intervalTime);
              this.clockInterval = setInterval(() => {
                this.horaReloj = this.dameTiempo();
              }, 1000);
            })



            this.loadInterval = setInterval(() => {
              this.apiService.getListaOfertas().subscribe(of => {
                if (of && of.ofertas != undefined && this.ofertas) {
                  this.refrescaOfertas(of.ofertas);
                }
              });
            }, 5000);

          }
          /*             this.vibration.vibrate(1000);
                      this.nativeAudio.preloadSimple('sonido1',this.soundFile).then(
                        (data)=>{this.nativeAudio.play('sonido1').then((data)=>{}), (error)=>{}}, 
                        (err)=>{console.log(err)}
                        ); */
        });
      });
    });
  }

  refrescaOfertas(ofertas) {
    this.ofertas.forEach(oferta => {
      ofertas.forEach(ofer => {
        if (oferta.idPartida == ofer.idPartida) {
          oferta.cantidadKg = ofer.cantidadKg;
        }
      });
    });
  }

  actualizarPujas() {
    let start = new Date().getTime() / 1000
    this.apiService.actualizarPujas({ id: this.loginObjectService.getclientes() }).subscribe((dataActu) => {

      let tiempoRespuesta = Math.ceil((new Date().getTime() / 1000) - start)
      /*if (tiempoRespuesta < 1) {
        tiempoRespuesta = 0
      }*/

      if (Math.round(dataActu.time.seconds) != this.clockTime) {
        this.timeRefresh = true;
        this.clockTime = dataActu.time.seconds - tiempoRespuesta;
      }
      this.relojActivo = dataActu.time.activa;
      this.ofertas.forEach(oferta => {
        dataActu.ofertas.forEach(ofer => {
          if (ofer.subastaId.trim() == oferta.idPartida) {
            oferta.estado = ofer.estado;
          }
        });
        dataActu.cuenta.forEach(cuenta => {
          if (cuenta.subastaId.trim() == oferta.idPartida) {
            oferta.numOfertas = cuenta.cuentaOferta;
          }
        });
      });
      if (this.intervalTime != dataActu.timeRefresh) {
        this.intervalTime = dataActu.timeRefresh;
        clearInterval(this.interval);
        this.interval = setInterval(() => { this.actualizarPujas(); }, this.intervalTime);
      }
    });
  }

  onFocus(event) {
    event.target.value = "";
  }

  onBlur(event, oferta) {

    try {
      if (oferta != '') {
        oferta.precioPuja = event.target.value
      }
      event.target.value = this.decimalPipe.transform(event.target.value.replaceAll(".", "").replaceAll(",", "."), "1.2-2", "es");


    } catch
    {
      this.mostrarToast("Cifra no valida", 2000);
    }
  }

  async mostrarToast(message, time) {
    let toast = await this.toastCtrl.create({
      message: message,
      duration: time,
      position: 'bottom',
      cssClass: 'toast-scheme',

    });
    toast.present();
  }

  async mostrarAlerta(message) {
    let finalMessage = '<div class="alertImageContainer"><img src="../../assets/img/alert.png" class="alertImage"><br>' + message + '</div>';
    const alert = await this.alertCtrl.create({
      cssClass: 'custom-alert-class',
      message: finalMessage,
      buttons: [{
        text: 'Cancelar',
        role: 'cancel',
        cssClass: "cancelarButton",
        handler: () => { this.ejecutar(false); alert.dismiss(); }
      }, {
        text: 'Confirmar',
        cssClass: "confirmarButton",
        handler: () => { this.ejecutar(true); alert.dismiss(); }
      }]
    });
    await alert.present();
  }

  async mostrarConfirmacion(message, type) {
    let finalMessage;
    if (type == 'confirmar') {
      finalMessage = '<div class="alertImageContainer"><img src="../../assets/img/confirmacion.png" class="alertImage"><br>' + message + '</div>';
    } else {
      finalMessage = '<div class="alertImageContainer"><img src="../../assets/img/error.png" class="alertImage"><br>' + message + '</div>';
    }
    const alert = await this.alertCtrl.create({
      cssClass: 'custom-alert-class',
      message: finalMessage,
      buttons: [{
        text: 'ok',
        cssClass: "okButton",
        handler: () => { this.ejecutar(true); alert.dismiss(); }
      }]
    });
    await alert.present();
  }

  ejecutar(ok) { }

  numberOnlyValidation(event: any) {
    const pattern = /[0-9.]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  dameTiempo() {
    if (this.clockTime > 0) {
      if (!this.timeRefresh) {
        this.clockTime--;
      } else {
        this.timeRefresh = false;
      }
      return new Date(this.clockTime * 1000).toISOString().substr(11, 8).split(":");
    } else {
      return ["00", "00", "00"];
    }
  }

  openPopup(imagen) { this.presentAlert(imagen); }

  async presentAlert(data) {
    const alert = await this.alertCtrl.create({
      cssClass: 'custom-alert-class',
      message: '<img src=' + data + '>',
      buttons: [{ text: 'ok', cssClass: "okButton", role: "cancel", }]
    });
    await alert.present();
  }

  pujar(oferta) {
    let params = {
      cliente: this.loginObjectService.getclientes(),
      id: oferta.idPartida,
      precio: oferta.precioPuja,
      cantidad: oferta.cantidadKg,
      cajakm: oferta.cajakm,
    }
    console.log(params)
    this.apiService.pujar(params).subscribe((data) => {
      console.log(data);
      if (data) {
        if (!data.exito) {
          this.mostrarToast(data.msg, 2000);
        } else {
          this.vibration.vibrate(1000);
        }
      }
    });
  }
}
